// src/helpers/rutaMarcas.js
import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE || "https://backre-miami.us-3.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

const p = (path) => `/${String(path || "").replace(/^\/+/, "")}`;

const getToken = () => localStorage.getItem("token") || "";

const auth = () => {
  const token = getToken();
  return token ? { headers: { token } } : {};
};

const debug =
  String(process.env.REACT_APP_DEBUG_API || "").toLowerCase() === "true";

const logUrl = (url, params, data, method = "GET") => {
  if (!debug) return;

  console.log("👉 METHOD:", method);
  console.log("👉 URL:", API.getUri({ url, params }));

  if (data) {
    console.log("📦 DATA ENVIADA:", data);
  }
};

async function req(method, url, { params, data, signal } = {}) {
  logUrl(url, params, data, method);

  try {
    const res = await API.request({
      method,
      url,
      params,
      data,
      signal,
      ...auth(),
    });

    return res.data;
  } catch (err) {
    if (debug) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message;

      console.log("🧯 API ERROR:", msg);
      console.log("🧯 STATUS:", err?.response?.status);
      console.log("🧯 DATA:", err?.response?.data);
    }

    throw err;
  }
}

/* ----------------------------- NORMALIZADORES ---------------------------- */

const clean = (v) => String(v ?? "").trim();

const unwrapMarca = (data) => {
  if (!data) return null;
  if (data?.marca) return data.marca;
  if (data?.data) return data.data;
  return data;
};

const unwrapMarcas = (data) => {
  if (Array.isArray(data)) return data;

  if (Array.isArray(data?.marcas)) return data.marcas;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.docs)) return data.docs;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.items)) return data.items;

  return [];
};

export const normalizarMarcaPayload = (payload = {}) => {
  const src = payload || {};

  return {
    ...src,
    nombre: clean(src.nombre).toUpperCase(),
    activo: src.activo ?? true,
  };
};

/* --------------------------------- MARCAS -------------------------------- */

export async function getMarcas({
  page = 1,
  limit = 50,
  q = "",
  signal,
} = {}) {
  const data = await req("GET", p("marcas"), {
    params: {
      page,
      limit,
      q: String(q || "").trim(),
    },
    signal,
  });

  const marcas = unwrapMarcas(data);

  return {
    marcas,
    total: Number(data?.total ?? marcas.length ?? 0),
    page: Number(data?.page ?? page),
    limit: Number(data?.limit ?? limit),
  };
}

export async function getMarcaById(id, { signal } = {}) {
  const data = await req("GET", p(`marcas/${id}`), { signal });
  return unwrapMarca(data);
}

export async function postMarca(payload, { signal } = {}) {
  const data = normalizarMarcaPayload(payload);

  if (debug) {
    console.log("🟢 postMarca PAYLOAD:", data);
  }

  return req("POST", p("marcas"), {
    data,
    signal,
  });
}

export async function putMarca(id, payload, { signal } = {}) {
  const data = normalizarMarcaPayload(payload);

  if (debug) {
    console.log("🟣 putMarca ID:", id);
    console.log("🟢 PAYLOAD:", data);
  }

  return req("PUT", p(`marcas/${id}`), {
    data,
    signal,
  });
}

export async function deleteMarca(id, { signal } = {}) {
  return req("DELETE", p(`marcas/${id}`), { signal });
}

// Compatible con:
// buscarMarcas({ q: "voge", limit: 20 })
// buscarMarcas("voge", 20)
export async function buscarMarcas(arg1 = {}, arg2 = 20) {
  let q = "";
  let limit = 20;
  let signal;

  if (typeof arg1 === "string" || typeof arg1 === "number") {
    q = String(arg1 || "").trim();
    limit = Number(arg2 || 20);
  } else {
    q = String(arg1?.q || "").trim();
    limit = Number(arg1?.limit || 20);
    signal = arg1?.signal;
  }

  if (!q || q.length < 2) return [];

  const data = await req("GET", p("marcas/buscar"), {
    params: { q, limit },
    signal,
  });

  return unwrapMarcas(data);
}